import AgritourismL1 from "./agritourism/AgritourismL1";
import AgritourismL2 from "./agritourism/AgritourismL2";
import AmbientalL1 from "./ambiental/AmbientalL1";
import AmbientalL2 from "./ambiental/AmbientalL2";
import AmbientalL3 from "./ambiental/AmbientalL3";
import EducationL1 from "./education/EducationL1";
import EducationL2 from "./education/EducationL2";
import FabricadosL1 from "./fabricados/FabricadosL1";
import FabricadosL2 from "./fabricados/FabricadosL2";
import GeneralConditionL1 from "./generalCondition/GeneralConditionL1";
import GeneralConditionL2 from "./generalCondition/GeneralConditionL2";
import GeneralConditionL3 from "./generalCondition/GeneralConditionL3";
import HealthL1 from "./health/HealthL1";
import HealthL2 from "./health/HealthL2";
import HealthL3 from "./health/HealthL3";
import InfraL1 from "./infra/InfraL1";
import InfraL2 from "./infra/InfraL2";
import InfraL3 from "./infra/InfraL3";
import InitialPageL1 from "./initial/InitialPageL1";
import InitialPageL2 from "./initial/InitialPageL2";
import ObraL1 from "./obra/ObraL1";
import ObraL2 from "./obra/ObraL2";
import ObraL3 from "./obra/ObraL3";
import styles from "./PageContent.module.css";
import ProdutionPageL1 from "./prodution/ProdutionPageL1";
import ProdutionPageL2 from "./prodution/ProdutionPageL2";
import SocialL1 from "./social/SocialL1";
import SocialL2 from "./social/SocialL2";
import SocialL3 from "./social/SocialL3";

function PageContent({
  view,
  distrito,
  menuFilterParams,
  options,
  setters,
  values,
}) {
  const { onDistrictMapChange, selectedOption, searchInput } = options;
  const searchControl = { selectedOption, searchInput };

  const {
    setImageControls,
    setAreaControls,
    setProdControls,
    setGeneralConditionsValuesControls,
    setHealthControls,
  } = setters;

  const {
    setCaptacaoAguaImage,
    setProdAgropecImage,
    setMapImage,
    setMapImage2,
    setImovelImage,
    setNaturezaImage,
    setCarroImage,
    setEnergiaImage,
    setAguaImage,
    setFossaImage,
    setLixoImage,
    setEsgotoImage,
    setFrequenciaExameImage,
    setAtendimentoAmbulanciaImage,
    setSistemaSaudeImage,
    setUsoMedicamentoImage,
    setDificuldadeAtendimentoImage,
    setQualidadeSSMunicipalImage,
    setQualidadeSSRuralImage,
    setPossuiDoencaCronicaImage,
    setTipoDoencaCronicaImage,
    setProgramaSaudeRuralImage,
  } = setImageControls;

  const { setAreaMin, setAreaMax } = setAreaControls;
  const { setProdMin, setProdMax } = setProdControls;

  const {
    setCarroProprioValue,
    setEnergiaEletricaValue,
    setAbastecimentoAguaValue,
    setTipoFossaValue,
    setDescarteLixoValue,
    setDescarteEsgotoValue,
  } = setGeneralConditionsValuesControls;

  const { areaValues, prodValues, generalConditionValues, healthValues } =
    values;

  const {
    setFrequenciaExameValue,
    setAtendimentoAmbulanciaValue,
    setSistemaSaudeValue,
    setUsoMedicamentoValue,
    setDificuldadeAtendimentoValue,
    setQualidadeSSMunicipalValue,
    setQualidadeSSRuralValue,
    setPossuiDoencaCronicaValue,
    setTipoDoencaCronicaValue,
    setProgramaSaudeRuralValue,
  } = setHealthControls;

  const { areaMin, areaMax } = areaValues;
  const { prodMin, prodMax } = prodValues;

  const handleAreaMin = (value) => {
    setAreaMin(value);
  };

  const handleAreaMax = (value) => {
    setAreaMax(value);
  };

  const handleProdMin = (value) => {
    setProdMin(value);
  };

  const handleProdMax = (value) => {
    setProdMax(value);
  };

  const setGeneralConditionsProperties1 = {
    setCarroProprioValue,
    setEnergiaEletricaValue,
    setAbastecimentoAguaValue,
    setCarroImage,
    setEnergiaImage,
    setAguaImage,
  };

  const setGeneralConditionsProperties3 = {
    setTipoFossaValue,
    setDescarteLixoValue,
    setDescarteEsgotoValue,
    setFossaImage,
    setLixoImage,
    setEsgotoImage,
  };

  const setHealthProperties1 = {
    setFrequenciaExameValue,
    setAtendimentoAmbulanciaValue,
    setSistemaSaudeValue,
    setFrequenciaExameImage,
    setAtendimentoAmbulanciaImage,
    setSistemaSaudeImage,
  };

  const setHealthProperties2 = {
    setUsoMedicamentoValue,
    setDificuldadeAtendimentoValue,
    setQualidadeSSMunicipalValue,
    setQualidadeSSRuralValue,
    setUsoMedicamentoImage,
    setDificuldadeAtendimentoImage,
    setQualidadeSSMunicipalImage,
    setQualidadeSSRuralImage,
  };

  const setHealthProperties3 = {
    setPossuiDoencaCronicaValue,
    setTipoDoencaCronicaValue,
    setProgramaSaudeRuralValue,
    setPossuiDoencaCronicaImage,
    setTipoDoencaCronicaImage,
    setProgramaSaudeRuralImage,
  };

  const componentsMap = {
    initialPage: [
      <InitialPageL1
        key="i1"
        distrito={distrito}
        onDistrictMapChange={onDistrictMapChange}
        setProdAgropecImage={setProdAgropecImage}
        setMapImage={setMapImage}
      />,

      <InitialPageL2
        key="i2"
        distrito={distrito}
        onDistrictMapChange={onDistrictMapChange}
        setImovelImage={setImovelImage}
      />,
    ],
    natureProduction: [
      <ProdutionPageL1
        key="p1"
        distrito={distrito}
        menuFilterParams={menuFilterParams}
        handles={{
          handleAreaMin,
          handleAreaMax,
          handleProdMin,
          handleProdMax,
        }}
        searchControl={searchControl}
        setNaturezaImage={setNaturezaImage}
      />,

      <ProdutionPageL2
        key="p2"
        distrito={distrito}
        menuFilterParams={menuFilterParams}
        areaMin={areaMin}
        areaMax={areaMax}
        prodMin={prodMin}
        prodMax={prodMax}
        setMapImage2={setMapImage2}
        searchControl={searchControl}
      />,
    ],
    generalCondition: [
      <GeneralConditionL1
        key={`${distrito}-g1`}
        distrito={distrito}
        menuFilterParams={menuFilterParams}
        searchControl={searchControl}
        generalConditionValues={generalConditionValues}
        setGeneralConditionsProperties1={setGeneralConditionsProperties1}
      />,

      <GeneralConditionL2
        key={`${distrito}-g2`}
        distrito={distrito}
        menuFilterParams={menuFilterParams}
        searchControl={searchControl}
        generalConditionValues={generalConditionValues}
        setCaptacaoAguaImage={setCaptacaoAguaImage}
      />,

      <GeneralConditionL3
        key={`${distrito}-g3`}
        distrito={distrito}
        menuFilterParams={menuFilterParams}
        searchControl={searchControl}
        generalConditionValues={generalConditionValues}
        setGeneralConditionsProperties3={setGeneralConditionsProperties3}
      />,
    ],
    health: [
      <HealthL1
        key={`${distrito}-h1`}
        distrito={distrito}
        healthValues={healthValues}
        setHealthProperties1={setHealthProperties1}
      />,

      <HealthL2
        key={`${distrito}-h2`}
        distrito={distrito}
        healthValues={healthValues}
        setHealthProperties2={setHealthProperties2}
      />,

      <HealthL3
        key={`${distrito}-h3`}
        distrito={distrito}
        healthValues={healthValues}
        setHealthProperties3={setHealthProperties3}
      />,
    ],
    agritourism: [
      <AgritourismL1 key={`${distrito}-agt1`} distrito={distrito} />,
      <AgritourismL2 key={`${distrito}-agt2`} distrito={distrito} />,
    ],
    education: [
      <EducationL1 key={`${distrito}-edu1`} distrito={distrito} />,
      <EducationL2 key={`${distrito}-edu2`} distrito={distrito} />,
    ],
    social: [
      <SocialL1 key={`${distrito}-soc1`} distrito={distrito} />,
      <SocialL2 key={`${distrito}-soc2`} distrito={distrito} />,
      <SocialL3 key={`${distrito}-soc3`} distrito={distrito} />,
    ],
    ambiental: [
      <AmbientalL1 key={`${distrito}-amb1`} distrito={distrito} />,
      <AmbientalL2 key={`${distrito}-amb2`} distrito={distrito} />,
      <AmbientalL3 key={`${distrito}-amb3`} distrito={distrito} />,
    ],
    fabricados: [
      <FabricadosL1 key={`${distrito}-fab1`} distrito={distrito} />,
      <FabricadosL2 key={`${distrito}-fab2`} distrito={distrito} />,
    ],
    infra: [
      <InfraL1 key={`${distrito}-inf1`} distrito={distrito} />,
      <InfraL2 key={`${distrito}-inf2`} distrito={distrito} />,
      <InfraL3 key={`${distrito}-inf3`} distrito={distrito} />,
    ],
    obra: [
      <ObraL1 key={`${distrito}-obr1`} distrito={distrito} />,
      <ObraL2 key={`${distrito}-obr2`} distrito={distrito} />,
      <ObraL3 key={`${distrito}-obr3`} distrito={distrito} />,
    ],
  };

  return (
    <div className={styles.pageContent}>
      <div className={styles.pages}>{componentsMap[view] || null}</div>
    </div>
  );
}

export default PageContent;
